/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full",style:({ height: _vm.widgets.content.height + 'px' })},[(_vm.widgets.content.isShow)?_c('div',{staticClass:"text-center text-neutral-400"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }